import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import {incorporate} from "incorporator"
import memo from "set-state-compare/build/memo"
import {Platform} from "react-native"
import PropTypes from "prop-types"
import React from "react"
import RenderHtml from "shared/render-html"
import xss from "xss"

const whiteList = {}
const defaultWhiteList = xss.whiteList
const extendedWhiteList = incorporate(whiteList, defaultWhiteList)
const attributesAllowedForAll = ["class", "data-controller", "data-remove-link", "height", "style", "width"]

for (const tagName in extendedWhiteList) {
  const allowedAttributes = extendedWhiteList[tagName]

  for (const attributeAllowedForAll of attributesAllowedForAll) {
    if (!allowedAttributes.includes(attributeAllowedForAll)) {
      allowedAttributes.push(attributeAllowedForAll)
    }
  }
}

const options = {whiteList: extendedWhiteList}

function sanitizeHtml(html) {
  return xss(html, options)
}

const SanitizedHtml = memo(shapeComponent(class SanitizedHtml extends ShapeComponent {
  static propTypes = {
    html: PropTypes.string.isRequired
  }

  render() {
    const {className, html, ...restProps} = this.props
    const sanitizedHtml = sanitizeHtml(html)

    if (Platform.OS == "web") {
      return (
        <div dangerouslySetInnerHTML={{__html: sanitizedHtml}} data-class={className} data-component="shared/sanitized-html" {...restProps} />
      )
    }

    return (
      <RenderHtml
        dataSet={this.cache("renderHtmlDataSet", {class: className, component: "shared/sanitized-html"}, [className])}
        source={sanitizedHtml}
      />
    )
  }
}))

export {options, sanitizeHtml}
export default SanitizedHtml
